<div class="container">

  <h1 class="text-center rounded text-black fw-bolder">Follow-Up Report</h1>
  <div class="d-flex gap-2">

    <mat-form-field appearance="outline" class="form-field-width">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="start" placeholder="Start date">
        <input matEndDate [(ngModel)]="end" placeholder="End date">
      </mat-date-range-input>
      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field-width">
      <mat-label>Centre</mat-label>
      <mat-select [(value)]="selectedCentre" (selectionChange)="centreSelected()">
        <mat-option value="All">All</mat-option>
        <mat-option *ngFor="let c of centres$ | async" [value]="c.centreCode">{{ c.centreName }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field-width">
      <mat-label>Select Child</mat-label>
      <mat-select [(value)]="selectedChild" (selectionChange)="OnChildSelected()" panelClass="custom-select-panel">
        <mat-select-trigger>
          {{ selectedChild ? selectedChild.firstName + ' ' + selectedChild.lastName : 'Select Child' }}
        </mat-select-trigger>
        <!-- Search Box -->
        <div class="mat-select-search">
          <input matInput [(ngModel)]="searchText" placeholder="Search" />
        </div>
        <!-- Filtered options -->
        <mat-option *ngFor="let c of children$ | async" [value]="c" style="height: auto">
          <ng-container *ngIf="!searchText || (c.firstName.toLowerCase().includes(searchText.toLowerCase()) || c.lastName.toLowerCase().includes(searchText.toLowerCase()))">
            {{ c.firstName }} {{ c.lastName }}
          </ng-container>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-mini-fab (click)="search()" color="accent">
      <mat-icon>search</mat-icon>
    </button>
    <button mat-mini-fab color="accent" (click)="mClear()"><mat-icon>clear</mat-icon></button>

    <li>
      <button
        mat-mini-fab color="accent"
        (click)="downloadExcel()">
        <mat-icon>download</mat-icon>
      </button>
    </li>
  </div>

  <section class="table-responsive">
    <table class="table table-striped table-bordered table-hover w-100">


      <thead class="thead-dark">
      <tr>
        <th>Sr. No.</th>
        <th>Centre</th>
        <th>Child Name</th>
        <th>Assessment Date</th>
        <ng-container *ngIf="mData.length >= 1">
          <ng-container *ngFor="let question of mData[0].questions">
            <th>{{ question.question }}</th>
          </ng-container>
        </ng-container>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let assessment of mData; let i=index">
        <td>{{ i + 1 }}</td>
        <td>{{ assessment.centreName }}</td>
        <td>{{ assessment.childName }}</td>
        <td>{{ assessment.date.toDate() | date: 'dd-MM-yyyy' }}</td>
        <ng-container *ngFor="let question of assessment.questions">
          <td [matTooltip]="question.remark">{{ question.ans }}</td>
        </ng-container>
      </tr>
      </tbody>
    </table>
  </section>

</div>
